<template>
  <div class="sent">
    <img class="sent__icon" src="../assets/email.svg" alt="" />
    <div class="sent__title">
      Request has been sent!
    </div>
    <div class="sent__text">
      Within 15 minutes, we will send a reply to email
    </div>
    <div class="sent__email">
      {{ email }}
    </div>
    <div class="sent__wrong">
      Indicated the wrong email?
    </div>
    <div class="sent__back" data-test-id="click:back send-request-again" @click="back">
      Send request again
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Emit } from 'vue-property-decorator'

@Component
export default class Sent extends Vue {
  @Prop() email: string

  @Emit('back')
  back(): void {}
}
</script>

<style lang="scss">
.sent {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 0 20px 8px;
  text-align: center;
  color: #4b4b4b;

  &__icon {
    width: 90px;
    height: 62px;
    margin-bottom: 16px;
  }

  &__title {
    margin-bottom: 8px;
    font-size: 24px;
    font-weight: 500;
    line-height: 130%;
  }

  &__text {
    margin-bottom: 16px;
    font-size: 16px;
    font-weight: 400;
    line-height: 130%;
  }

  &__email {
    margin-bottom: 24px;
    font-size: 20px;
    font-weight: 700;
    line-height: 130%;
  }

  &__wrong {
    position: relative;
    width: 100%;
    margin-bottom: 8px;
    padding-top: 24px;
    font-size: 16px;
    font-weight: 400;
    line-height: 130%;

    &:before {
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      display: block;
      height: 1px;
      content: '';
      opacity: 0.1;
      background: #00997d;
    }
  }

  &__back {
    cursor: pointer;
    color: #00997d;
    font-size: 16px;
    font-weight: 700;
    line-height: 130%;
    text-decoration-line: underline;
  }
}
</style>
